import { CSSProperties } from 'react';

interface ImageProps {
  children: React.ReactNode;
  classes?: string;
  styles?: CSSProperties;
}

export const Img = ({ children, classes, styles, ...props }: ImageProps) => (
  <img className={classes} style={styles} {...props}>
    {children}
  </img>
);
